// components/TreeCatalogSection.jsx
import React from "react";
import ContentSplitSections from "../components/ContentSplitSections";
import { treeCatalog } from "../data/treeCatalog";

// Build the "text" block exactly like your existing sections: paragraphs with \n\n
function buildText(item) {
  const headerLine = item.primary
    ? `${item.category}, ${item.primary}`
    : item.category;

  if (item.others && item.others.length) {
    return `${headerLine}\n\nAlso offered: ${item.others.join(", ")}`;
  }

  // fallback to a short description when there are no "others"
  return `${headerLine}\n\n${item.desc || ""}`.trim();
}

// Map catalog → ContentSplitSections sections[]
function toSections(catalog) {
  return catalog.map((item, i) => ({
    title: item.category,            // keep category as title on the card
    text: buildText(item),
    image: item.image,
    alt: item.alt || `${item.category} ${item.primary || ""}`.trim(),
    reverse: i % 2 === 1,            // alternate left/right like your current page
  }));
}

export default function TreeCatalogSection({
  items = treeCatalog,
  limit,
  categories,
  className = "",
}) {
  let list = items;
  if (categories?.length) {
    const set = new Set(categories.map((c) => c.toLowerCase()));
    list = list.filter((t) => set.has(t.category.toLowerCase()));
  }
  if (limit) list = list.slice(0, limit);

  const sections = toSections(list);

  return <ContentSplitSections sections={sections} className={className} />;
}
